<script setup>
import Form from "../../Registration/components/Form.vue"
import {useBookingStore} from "../../Registration/stores/bookingStore";
import {useLivewireManager} from "../../Registration/stores/livewireManagerStore";
import {onMounted} from 'vue'
import {useSettingsManager} from "../../Registration/stores/settingsManagerStore";
import {useStepManager} from "../../Registration/stores/stepsManager";
import {useCaptchaManager} from "../../Registration/stores/captchaManagerStore";

const {
    forms,
    livewire,
    booking_data: bookingData,
    settings,
    core,
    steps,
    field_limits: fieldLimits,
} = defineProps([
    'forms',
    'settings',
    'livewire',
    'booking_data',
    'core',
    'steps',
    'field_limits',
])

const bookingStore = useBookingStore();
const livewireManager = useLivewireManager();
const settingsManager = useSettingsManager();
const stepsManager = useStepManager();
const captchaManager = useCaptchaManager();

settingsManager.initialize({settings, core, fieldLimits});

onMounted(() => {
    bookingStore.initialize(forms, bookingData);
    livewireManager.register(livewire.component);
    stepsManager.initialize(steps);
    captchaManager.initialize();
})
</script>

<template>
    <div class="registration">
        <div class="registration-form-wrapper">
            <Form />
        </div>
    </div>
</template>

<style scoped>

</style>
